import { LegacyText } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

export const Title = styled(LegacyText).attrs<unknown>({
  fontSize: ['2.8rem', '4.4rem', '4.4rem', '4.4rem'],
  fontWeight: 'bold',
  lineHeight: ['3.6rem', '5.6rem', '5.6rem', '5.6rem'],
  as: 'h2',
  type: 'main',
})`
  text-wrap: balance;
  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: pre;
  `}
`;

export const Subtitle = styled(LegacyText).attrs<unknown>({
  fontSize: ['2rem', '1.8rem', '1.8rem', '1.8rem'],
  lineHeight: '2.8rem',
  type: 'main',
})`
  text-wrap: balance;
  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: pre;
  `}
`;
